import { render } from "./accountSubtitle.vue?vue&type=template&id=62046869&scoped=true"
import script from "./accountSubtitle.vue?vue&type=script&lang=js"
export * from "./accountSubtitle.vue?vue&type=script&lang=js"

import "./accountSubtitle.vue?vue&type=style&index=0&id=62046869&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-62046869"

export default script